import React from "react";
import {
  CsplTable as Table,
  DatePicker,
  FieldDropSide,
  Select,
  Link,
  SearchableList,
  MultiSelectDropdown,
} from "../../../components";
import TableHead from "../../../components/CsplTable/TableHead";
import { getTwoDecimalPlaces } from "../../../utils";
const columns = [
  {
    label: "Particulars",
    className: "table-width-40",
    columnName: "particulars",
  },
  {
    label: "Roth",
    className: "table-width-20",
    columnName: "roth",
  },
  {
    label: "Pre-tax",
    className: "table-width-20",
    columnName: "preTax",
  },
  {
    label: "Employer Match",
    className: "table-width-20",
    columnName: "employerMatch",
  },
];
const data = [
  {
    particulars: "Employee Contribution Loan payable A/c",
    roth: 340123,
    preTax: 102123,
    employerMatch: 442246,
  },
  {
    particulars: "Employee  Contribution Loan Interest payable A/C",
    roth: 340123,
    preTax: 102123,
    employerMatch: 442246,
  },
  {
    particulars: "Employer Contribution Loan payable - Vested A/C",
    roth: 340123,
    preTax: 102123,
    employerMatch: 442246,
  },
  {
    particulars: "Employer Contribution Loan Interest payable - Vested A/C",
    roth: 340123,
    preTax: 102123,
    employerMatch: 442246,
  },
];
const data2 = [
  {
    particulars: "Employee Contribution Loan payable A/c",
    roth: 340123,
    preTax: 102123,
    employerMatch: 442246,
  },
  {
    particulars: "Employer Contribution Loan payable - Vested A/C",
    roth: 340123,
    preTax: 102123,
    employerMatch: 442246,
  },
];
const roth = {
  particulars: "Opening balance total",
  roth: 340123,
  preTax: 102123,
  employerMatch: 442246,
};
const repaymentTotal = {
  particulars: "Repayments total",
  roth: 340123,
  preTax: 102123,
  employerMatch: 442246,
};
const finalParticulars = [
  {
    particulars: "Loan principal outstanding balance",
    roth: 340123,
    preTax: 102123,
    employerMatch: 442246,
  },
  {
    particulars: "Loan Interest outstanding balance",
    roth: 340123,
    preTax: 102123,
    employerMatch: 442246,
  },
  {
    particulars: "Total Loan outstanding balance",
    roth: 340123,
    preTax: 102123,
    employerMatch: 442246,
  },
];
export const ParticipantLoanAccountBalance = (props) => {
  return (
    <Table>
      <Table.Thead>
        <Table.Tr>
          {columns.map((e, i) => (
            <Table.Th className={e.className}>{e.label}</Table.Th>
          ))}
        </Table.Tr>
      </Table.Thead>
      <Table.Tbody>
        <Table.Tr>
          <Table.Th className="table-sub-header">Opening Balance</Table.Th>
        </Table.Tr>
        {data.map((e, i) => (
          <Table.Tr>
            {columns.map((f, j) =>
              f.columnName === "particulars" ? (
                <Table.Td className={f.className}>{e[f.columnName]}</Table.Td>
              ) : (
                <Table.Td className={f.className}>
                  ${getTwoDecimalPlaces(e[f.columnName])}
                </Table.Td>
              )
            )}
          </Table.Tr>
        ))}
        <Table.Tr>
          {columns.map((f, j) =>
            f.columnName === "particulars" ? (
              <Table.Td className={`${f.className} table-total-value`}>
                {roth[f.columnName]}
              </Table.Td>
            ) : (
              <Table.Td className={`${f.className} table-total-value`}>
                ${getTwoDecimalPlaces(roth[f.columnName])}
              </Table.Td>
            )
          )}
        </Table.Tr>
        <Table.Tr>
          <Table.Th className="table-sub-header">Repayments</Table.Th>
        </Table.Tr>
        {data2.map((e, i) => (
          <Table.Tr>
            {columns.map((f, j) =>
              f.columnName === "particulars" ? (
                <Table.Td className={f.className}>{e[f.columnName]}</Table.Td>
              ) : (
                <Table.Td className={f.className}>
                  ${getTwoDecimalPlaces(e[f.columnName])}
                </Table.Td>
              )
            )}
          </Table.Tr>
        ))}
        <Table.Tr>
          {columns.map((f, j) =>
            f.columnName === "particulars" ? (
              <Table.Td className={`${f.className} table-total-value`}>
                {repaymentTotal[f.columnName]}
              </Table.Td>
            ) : (
              <Table.Td className={`${f.className} table-total-value`}>
                ${getTwoDecimalPlaces(repaymentTotal[f.columnName])}
              </Table.Td>
            )
          )}
        </Table.Tr>
        {finalParticulars.map((e, i) => (
          <Table.Tr>
            {columns.map((f, j) =>
              f.columnName === "particulars" ? (
                <Table.Td className={`${f.className} table-total-value`}>
                  {e[f.columnName]}
                </Table.Td>
              ) : (
                <Table.Td className={`${f.className} table-total-value`}>
                  ${getTwoDecimalPlaces(e[f.columnName])}
                </Table.Td>
              )
            )}
          </Table.Tr>
        ))}
      </Table.Tbody>
    </Table>
  );
};
